module.exports = __webpack_public_path__ + "static/media/video_insta_android.2c0cce59.svg";